import * as Types from 'actions/types';

export default function (state=null,action){
    switch(action.type){
        case Types.FETCH_APPS:
            return action.payload.apps;
        case Types.APP_INSTALLED:
            return state.map(app=>{
                if(app.ID !== action.payload.appID) return {...app};
                else if(!app.configuration) return {...app,...action.payload, ID:action.payload.appID};
                return {...app,...action.payload, ID:action.payload.appID, configuration:{...action.payload.configuration, template:{...app.configuration.settings || {}}, settings:{...action.payload.configuration.settings}}}; // this is quite messy, combining appRecord and appInstallationRecord data
            });
        case Types.APP_UNINSTALLING:
            return state.map(app=>{
                if(app.appInstallationID !== action.payload) return {...app};
                return {...app,uninstalling:true};
            });
        case Types.APP_RESETTING:
            return state.map(app=>{
                if(app.appInstallationID !== action.payload) return {...app};
                return {...app,resetting:true};
            });
        case Types.APP_UNINSTALLED:
            return state.map(app=>{
                if(app.appInstallationID !== action.payload) return {...app};
                return {...app,appInstallationID:null,uninstalling:null};
            });
        case Types.CONFIG_OPEN:
            return state.map(app=>{
                if(app.ID !== action.payload) return {...app};
                return {...app,configOpen:true};
            });
        case Types.CONFIG_CLOSE:
            return state.map(app=>{
                if(app.ID !== action.payload) return {...app};
                return {...app,configOpen:false};
            });
        case Types.SETTINGS_SAVING:
            return state.map(app=>{
                return {...app,saving:true};
            });
        case Types.SETTINGS_SAVED:
            return state.map(app=>{
                if(app.appInstallationID !== action.payload.appID) return {...app};
                return {...app, saving: null, configuration:{...app.configuration, settings: action.payload.settings}};
            });
        case Types.LOGOUT:
            return null;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/apps.js